import { csvDownloadConstants } from '../../_constants';
import { csvDownloadService } from '../../_services';

export const csvDownloadAction = {
    csvDownloadHandler
};

function csvDownloadHandler(data,callback) {
    return dispatch => {
        dispatch(request());
        csvDownloadService.csvDownloadHandler(data)
            .then(
                csvDownload => {
                    dispatch(success(csvDownload));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: csvDownloadConstants.REQUEST_CSV_DOWNLOAD } }
    function success(csvDownload) { return { type: csvDownloadConstants.RECIEVE_CSV_DOWNLOAD, csvDownload } }
    function failure(error) { return { type: csvDownloadConstants.ERROR_CSV_DOWNLOAD, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/CsvDownloads/csvDownloads.action.js